<oui-button style="width: 100%" type="text" iconPrefix="check" (click)="onActivate()" *ngIf="!isLoading"
  >Passer en actif</oui-button
>
<div class="flex-horizontal flex-center justify-center" *ngIf="isLoading">
  <oui-loading size="small"></oui-loading>
</div>
